import React, { Component } from 'react';
import {Row} from 'react-bootstrap';
import { Route, withRouter, Switch } from 'react-router-dom';
import '../../../styles/variables.css';
import './BackendMain.css';
import BackendSidenav from '../components/BackendSidenav';
import BackendVacancies from '../Vacancies/BackendVacancies';
import BackendJobsActions from '../BackendJobs/BackendJobsActions';
import VacancyEdit from '../Vacancies/VacancyEdit';
import Applicants from '../components/Applicants';

class BackendMain extends Component {
    render(){
        return(
            <div className="container">
                <Row className="backend-dashboard">
                    <BackendSidenav />
                    <div className="b-main">
                        <Switch>
                            <Route exact path={`${this.props.match.url}/vacancies`} component={BackendVacancies}/>
                            <Route exact path={`${this.props.match.url}/mycompany`} component={BackendJobsActions}/>
                            <Route exact path={`${this.props.match.url}/vacancies/edit-job/:id`} component={VacancyEdit}/>
                            <Route exact path={`${this.props.match.url}/vacancies/create/`} component={VacancyEdit}/>
                            <Route exact path={`${this.props.match.url}/vacancies/applicants/:id/:owner`} component={Applicants} />
                        </Switch>
                    </div>
                </Row>
            </div>
        )
    }
}
export default withRouter(BackendMain);